import { render, staticRenderFns } from "./leadsDashboardLeadsList.vue?vue&type=template&id=2da97ffa&scoped=true"
import script from "./leadsDashboardLeadsList.vue?vue&type=script&lang=js"
export * from "./leadsDashboardLeadsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da97ffa",
  null
  
)

export default component.exports